import React from 'react'
import { Pressable, StyleSheet, View } from 'react-native'
import MaterialCommunityIcons from '@expo/vector-icons/MaterialCommunityIcons'
import i18n from 'utils/i18n'

const ScannerControls = ({ onBack, onSwitchCamera, onSettings }) => {
	const actions = [
		{ key: 'back', icon: 'arrow-left', onPress: onBack },
		{ key: 'switch_camera', icon: 'camera-flip-outline', onPress: onSwitchCamera },
		{ key: 'settings', icon: 'cog-outline', onPress: onSettings },
	];
	return (
		<View style={ styles.container }>
			{ actions.filter( ( action ) => {
				return Boolean( action.onPress );
			} ).map( ( action ) => {
				return (
					<Pressable
						key={ action.key }
						accessibilityRole="button"
						accessibilityLabel={ i18n.t( `lunch_scanner.index.${action.key}` ) }
						onPress={ action.onPress }
						style={ ({ pressed }) => {
							return [ styles.button, pressed && styles.pressed ];
						} }>
						<MaterialCommunityIcons name={ action.icon } size={ 22 } color="#ffffff" />
					</Pressable>
				);
			} ) }
		</View>
	);
}

const styles = StyleSheet.create({
	container: { flexDirection: 'row', gap: 8, paddingRight: 12 },
	button: {
		width: 44,
		height: 44,
		borderRadius: 22,
		backgroundColor: 'rgba(255, 255, 255, 0.18)',
		alignItems: 'center',
		justifyContent: 'center',
	},
	pressed: { backgroundColor: 'rgba(255, 255, 255, 0.35)' },
});

export default ScannerControls;
